import { render, staticRenderFns } from "./ViewEvent.vue?vue&type=template&id=17a6b36c&"
import script from "./ViewEvent.vue?vue&type=script&lang=ts&"
export * from "./ViewEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewEvent.vue"
export default component.exports